var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuantoriWhitecolor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 587.2",
    style: {
      enableBackground: "new 0 0 1920 587.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E6302F;}\n\t.st2{fill:#F7D000;}\n\t.st3{fill:#008EB5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786.5,301.8c0-21.2-7.4-39.1-22.1-53.7c-14.7-14.6-33.2-22-55.5-22s-40.9,7.4-55.7,22.1 c-14.8,14.7-22.3,32.6-22.3,53.6c0,21.2,7.4,39.1,22.1,53.7c14.7,14.6,33.2,21.9,55.5,21.9c16,0,30.5-4.2,43.5-12.5l16.1,14.4 l20.5-22.8l-15.1-12.8C782.2,331.3,786.5,317.2,786.5,301.8z M748.8,322.3l-24-21.7l-20.5,23l23.8,20.3c-6,2.6-12.4,4-19.2,4 c-12.8,0-23.4-4.5-31.8-13.4c-8.4-8.9-12.5-19.8-12.5-32.6c0-13,4.1-23.9,12.3-32.7c8.2-8.8,18.7-13.3,31.6-13.3 c12.8,0,23.4,4.5,31.8,13.4c8.4,8.9,12.5,19.8,12.5,32.6C752.8,309.6,751.5,316.4,748.8,322.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M909.8,312.4c0,11.4-2.8,20.1-8.3,26.1s-13.3,9-23.3,9s-17.8-3.1-23.3-9.3c-5.5-6.2-8.3-15.2-8.3-26.9v-82.8 h-32.2v83.6c0,21.2,5.6,37.3,16.7,48.4c11.2,11.1,26.7,16.6,46.6,16.6c20.1,0,35.8-5.6,47.1-16.7c11.4-11.1,17-27.6,17-49.3v-82.6 h-32.2v83.9H909.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1023.4,227.5L960.7,375h32.8l13.4-32.8h61.9l13.4,32.8h33.7l-62.7-147.4h-29.8V227.5z M1018.4,313.7 l19.4-47.5l19.4,47.5H1018.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1238.7,318.7 1170.2,228.6 1140.5,228.6 1140.5,375 1172.2,375 1172.2,281.9 1243.1,375 1270.5,375  1270.5,228.6 1238.7,228.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1297.3,258.3 1341.8,258.3 1341.8,375 1374,375 1374,258.3 1418.5,258.3 1418.5,228.6 1297.3,228.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1510.5,226.1c-22.3,0-40.9,7.4-55.7,22.1c-14.8,14.7-22.3,32.6-22.3,53.6c0,21.2,7.4,39.1,22.1,53.7 s33.2,21.9,55.5,21.9s40.9-7.4,55.7-22.1c14.8-14.7,22.3-32.6,22.3-53.6c0-21.2-7.4-39.1-22.1-53.7 C1551.3,233.4,1532.8,226.1,1510.5,226.1z M1542.1,334.5c-8.2,8.9-18.7,13.3-31.6,13.3s-23.4-4.5-31.8-13.4s-12.5-19.8-12.5-32.6 c0-13,4.1-23.9,12.3-32.7c8.2-8.8,18.7-13.3,31.6-13.3s23.4,4.5,31.8,13.4s12.5,19.8,12.5,32.6 C1554.4,314.7,1550.3,325.6,1542.1,334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1739.7,277.3c0-14.2-4.2-25.5-12.5-33.9c-9.9-9.9-24.1-14.8-42.7-14.8h-66.9V375h32.2v-46.8h24.9l31.8,46.8 h37.6l-35.8-52.3C1729.2,314.9,1739.7,299.8,1739.7,277.3z M1700.6,293.9c-4.3,3.8-10.4,5.7-18.2,5.7h-32.6v-42h32 c8,0,14.1,1.8,18.6,5.3c4.5,3.6,6.7,8.8,6.7,15.6C1707.1,285,1704.9,290.1,1700.6,293.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1772.3,
    y: 228.6,
    className: "st0",
    width: 32.2,
    height: 146.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.5,307.1c0,33.7,27.3,61.1,61.1,61.1c33.7,0,61.1-27.3,61.1-61.1c0-33.7-27.3-61.1-61.1-61.1 S264.5,273.4,264.5,307.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.6,176.2L429.6,176.2c-4.9,6.2-4.3,15.1,1.4,20.5c39,37.3,57,94.1,42,149.9c-0.3,1.2-0.6,2.3-1,3.4 c-2.2,7.5,1.8,15.5,9.1,18.4c8.4,3.3,17.8-1.4,20.3-10c0.4-1.3,0.7-2.6,1.1-3.9c17.9-67-3.7-135.2-50.5-179.9 C445.6,168.4,435.2,169.2,429.6,176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289.4,158.8c7.7-1.9,12.7-9.3,11.5-17.1l0,0c-1.3-8.8-9.9-14.7-18.6-12.6c-62.9,15.3-115.7,63.6-133.7,130.6 c-0.3,1.3-0.7,2.6-1,3.9c-2.1,8.8,3.6,17.5,12.6,18.8c7.8,1.2,15.2-3.7,17-11.4c0.3-1.2,0.6-2.3,0.9-3.5 C193.1,211.8,237.1,171.6,289.4,158.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.9,462.6c-2.9-7.4-11-11.2-18.6-9c-25.9,7.6-54.2,8.4-82.2,0.9s-52.1-22.4-70.8-41.9 c-5.5-5.7-14.4-6.4-20.6-1.5l0,0c-7,5.5-7.8,15.9-1.7,22.3c22.4,23.6,51.4,41.5,85.2,50.5c33.7,9,67.8,8,99-1.2 C385.7,480.3,390.2,470.9,386.9,462.6L386.9,462.6z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 369,
    cy: 144.9,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 444.2,
    cy: 425.9,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 163.5,
    cy: 350.7,
    r: 48
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantoriWhitecolor);
export default __webpack_public_path__ + "static/media/quantori_white+color.eb8e9c9eed5f77dc5510d199453c3350.svg";
export { ForwardRef as ReactComponent };